import {BackendResponse} from '@common/http/backend-response/backend-response';
import {apiClient} from '@common/http/query-client';
import {showHttpErrorToast} from '@common/http/show-http-error-toast';
import {useMutation} from '@tanstack/react-query';
import {
  getBootstrapData,
  mergeBootstrapData,
} from '@ui/bootstrap-data/bootstrap-data-store';
import {Localization} from '@ui/i18n/localization';

interface ChangeLocaleResponse extends BackendResponse {
  locale: Localization;
}

export function useChangeLocale() {
  return useMutation({
    mutationFn: (props: {locale?: string}) =>
      apiClient
        .post<ChangeLocaleResponse>(`users/me/locale`, props)
        .then(r => r.data),
    onSuccess: response => {
      // the response carries the new locale WITH its lines loaded; swap it
      // into the locales list so the switch applies immediately - the page
      // only embeds lines for the locale that was active when it loaded
      mergeBootstrapData({
        i18n: {
          locales: getBootstrapData().i18n.locales.map(locale =>
            locale.language === response.locale.language
              ? {
                  name: response.locale.name,
                  language: response.locale.language,
                  lines: response.locale.lines ?? {},
                }
              : locale,
          ),
          active: response.locale.language,
        },
      });
    },
    onError: err => showHttpErrorToast(err),
  });
}
